'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { useRouter } from 'next/navigation';

export default function Header() {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll(); // Check initial scroll position
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Use mounted state to prevent hydration mismatch
  const isScrolled = mounted && scrolled;

  return (
    <nav
      className={`fixed top-0 w-full z-[100] px-4 py-4 transition-all duration-500 ${
        isScrolled ? 'py-3' : 'py-5'
      }`}
    >
      <div
        className={`max-w-6xl mx-auto flex items-center justify-between rounded-2xl px-6 py-3 transition-all duration-500 ${
          isScrolled
            ? 'glass-card shadow-xl shadow-black/30'
            : 'bg-transparent'
        }`}
      >
        {/* Logo */}
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => router?.push('/programme-partenaire')}
        >
          <AppLogo
            src="/assets/images/app_logo.png"
            size={48}
            text="GiteZen"
            onClick={() => router?.push('/programme-partenaire')}
          />
        </div>

        {/* Nav links */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-cream/60">
          <a href="#programme" className="hover:text-cream transition-colors duration-200">
            Programme
          </a>
          <a href="#avantages" className="hover:text-cream transition-colors duration-200">
            Avantages
          </a>
          <a href="#processus" className="hover:text-cream transition-colors duration-200">
            Processus
          </a>
          <a href="#faq" className="hover:text-cream transition-colors duration-200">
            FAQ
          </a>
        </div>

        {/* CTA */}
        <a
          href="/candidature"
          className="inline-flex items-center gap-2 bg-moss text-cream text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-moss-light transition-all duration-300 shadow-lg shadow-moss/20"
        >
          Candidater
        </a>
      </div>
    </nav>
  );
}